const employeeReportActionTypes = {

  // Report List - Activity
  FETCH_EMPLOYEE_ACTIVITY_REPORT_REQUEST: "FETCH_EMPLOYEE_ACTIVITY_REPORT_REQUEST",
  FETCH_EMPLOYEE_ACTIVITY_REPORT_SUCCESS: "FETCH_EMPLOYEE_ACTIVITY_REPORT_SUCCESS",
  FETCH_EMPLOYEE_ACTIVITY_REPORT_FAILURE: "FETCH_EMPLOYEE_ACTIVITY_REPORT_FAILURE",

  // Report List - My Activity
  FETCH_MY_ACTIVITY_REPORT_REQUEST: "FETCH_MY_ACTIVITY_REPORT_REQUEST",
  FETCH_MY_ACTIVITY_REPORT_SUCCESS: "FETCH_MY_ACTIVITY_REPORT_SUCCESS",
  FETCH_MY_ACTIVITY_REPORT_FAILURE: "FETCH_MY_ACTIVITY_REPORT_FAILURE",

  // Age Wise Report
  FETCH_AGE_WISE_REPORT_REQUEST: "FETCH_AGE_WISE_REPORT_REQUEST",
  FETCH_AGE_WISE_REPORT_SUCCESS: "FETCH_AGE_WISE_REPORT_SUCCESS",
  FETCH_AGE_WISE_REPORT_FAILURE: "FETCH_AGE_WISE_REPORT_FAILURE",

  // Birthday Report
  FETCH_BIRTHDAY_REPORT_REQUEST: "FETCH_BIRTHDAY_REPORT_REQUEST",
  FETCH_BIRTHDAY_REPORT_SUCCESS: "FETCH_BIRTHDAY_REPORT_SUCCESS",
  FETCH_BIRTHDAY_REPORT_FAILURE: "FETCH_BIRTHDAY_REPORT_FAILURE",

  // Exemption / Resigned Report
  FETCH_EXEMPTION_RESIGNED_REPORT_REQUEST: "FETCH_EXEMPTION_RESIGNED_REPORT_REQUEST",
  FETCH_EXEMPTION_RESIGNED_REPORT_SUCCESS: "FETCH_EXEMPTION_RESIGNED_REPORT_SUCCESS",
  FETCH_EXEMPTION_RESIGNED_REPORT_FAILURE: "FETCH_EXEMPTION_RESIGNED_REPORT_FAILURE",

  RESET_EMPLOYEE_REPORT: "RESET_EMPLOYEE_REPORT",
};

export default employeeReportActionTypes;
